import './modules/survey-statistics/survey-statistics.module';
import './modules/survey-search/survey-search-module';
import './modules/survey-list/survey-list-module';
import './modules/survey-carousel/carousel-survey-module';
// @ts-ignore
window.SMB_WIDGETS_VERSION = '0.1.0-3';
